import billingModule from '../../billing.module';

class BillingPreviewService {
    constructor($q, billingConfigurationApiService, billingPreviewApiService) {
        this.$q = $q;
        this.billingConfigurationApiService = billingConfigurationApiService;
        this.billingPreviewApiService = billingPreviewApiService;
    }

    getUpcomingCharges() {
        var deferred = this.$q.defer();

        this.$q
            .all([
                this.billingConfigurationApiService.getUpcomingChargesConfiguration(),
                this.billingPreviewApiService.getUpcomingCharges()
            ])
            .then(data => {
                var table = {};

                table.size = data[1].size;
                table.limit = data[1].limit;
                table.offset = data[1].offset;

                if (data[1].items) {
                    table.rows = data[1].items.map(row => {
                        row.columns = data[0].fields.reduce((obj, field) => {
                            var column = {
                                type: field.type
                            };

                            if (field.type == 'text') {
                                obj.push({
                                    ...column,
                                    value: row[field.name]
                                });
                            } else {
                                obj.push({
                                    ...column,
                                    ...row[field.name]
                                });
                            }

                            return obj;
                        }, []);

                        return row;
                    });
                }

                deferred.resolve(table);
            }, deferred.reject);

        return deferred.promise;
    }
}

export default billingModule.service(
    'billingPreviewService',
    BillingPreviewService
);



// WEBPACK FOOTER //
// ./modules/billing/services/preview/billingPreview.service.js